module.exports = __webpack_public_path__ + "static/img/图层 35.f73b0cbf.png";